import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import "./circularProgressTrack.css";

var CircularProgressTrack = function CircularProgressTrack(_ref) {
  var id = _ref.id,
      size = _ref.size,
      variant = _ref.variant,
      hasTrack = _ref.hasTrack,
      className = _ref.className,
      offsetPercentage = _ref.offsetPercentage,
      otherProps = _objectWithoutProperties(_ref, ["id", "size", "variant", "hasTrack", "className", "offsetPercentage"]);

  var strokeWidthTable = {
    16: 2,
    24: 2,
    32: 3,
    48: 3,
    64: 3,
    96: 3
  };
  var radius = parseInt(size, 10) / 2 - strokeWidthTable[size] / 2;
  var circumference = 2 * Math.PI * radius;
  var dasharray = "".concat(circumference * (offsetPercentage / 100), " ").concat(circumference * ((100 - offsetPercentage) / 100));
  return /*#__PURE__*/React.createElement("svg", _extends({}, otherProps, {
    className: classNames('lms-CircularProgressTrack', "lms-CircularProgressTrack--".concat(size), "lms-CircularProgressTrack--".concat(variant), className),
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 ".concat(size, " ").concat(size),
    role: "img",
    "aria-label": "Circular progress indicator"
  }), hasTrack && /*#__PURE__*/React.createElement("circle", {
    className: "lms-CircularProgressTrack-track",
    strokeWidth: "".concat(strokeWidthTable[size], "px"),
    cx: size / 2,
    cy: size / 2,
    r: size / 2 - strokeWidthTable[size] / 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lms-CircularProgressTrack-spinner",
    strokeWidth: "".concat(strokeWidthTable[size], "px"),
    cx: size / 2,
    cy: size / 2,
    r: size / 2 - strokeWidthTable[size] / 2,
    style: offsetPercentage ? {
      strokeDasharray: dasharray
    } : null
  }));
};

CircularProgressTrack.propTypes = {
  /** Add an optional ID to this element. */
  id: PropTypes.string,

  /** Sets the loader size and line weight. */
  size: PropTypes.oneOf(['16', '24', '32', '48', '64', '96']),

  /** Establishes the stroke color. */
  variant: PropTypes.oneOf(['teal', 'green', 'gray', 'dark', 'light']),

  /** Turn on or off a background track. */
  hasTrack: PropTypes.bool,

  /** Add custom classes to this element. */
  className: PropTypes.string,

  /** The percentage (0-100) of the circular indicator that should be filled in. */
  offsetPercentage: PropTypes.number
};
CircularProgressTrack.defaultProps = {
  id: undefined,
  size: '64',
  variant: 'teal',
  hasTrack: true,
  className: undefined,
  offsetPercentage: undefined
};
export default CircularProgressTrack;